import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Button, Tooltip, Avatar, IconButton, TextField, FormControl, FormLabel, FormControlLabel, Switch, Dialog, DialogContent, DialogTitle, DialogActions, CircularProgress, Table, TableHead, TableBody, TableRow, TableCell, TableContainer, Paper} from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import AddIcon from '@material-ui/icons/Add';
import InfoIcon from '@material-ui/icons/Info';
import PhotoCamera from '@material-ui/icons/PhotoCamera';
import { DeletePopUp, EmptyCollection, PageLoader } from '../../shared_elements'
import { globalGetService, globalPostService, globalPutService } from '../../../globalServices';
import { checkApiStatus, checkPermission, getLocalStorageInfo } from '../../utils_v2';
import { jetStreamInstance, smbcInstance, testLessor } from '../../../shared/components';
import { regexConstants } from '../../../constants/regEx';

const useStyles = makeStyles((theme) => ({
    root: {
      '& > *': {
        margin: theme.spacing(1),
      },
    },
    input: {
      display: 'none',
    },
}));
const EditLessorProfile = ({editProfile, toggleModalFn, getResponseBack}) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [lessor, setLessor] = useState(editProfile.data);
    const [error, setError] = useState({});
    const onFieldChange = (key, value) => {
        setLessor({...lessor,[key]:value})
    }
    const onEditLessorProfile = () => {
        let validationInputs = {
            name: lessor?.name?.trim()?.length ? '' : 'Please enter Name',
            email_signature: regexConstants.alphanumbericWithSpecChar.test(lessor?.email_signature ?? '') ? '' : 'Please enter valid Email Signature'
        }
        let payload = Object.assign({}, { ...lessor, email_signature: lessor.email_signature?.replace(/\r?\n/g, "\n") || "" });
        if(Object.keys(validationInputs).every((k) => { return validationInputs[k] === ''})){
            setLoading(true);
            globalPutService(`console/lessor_tile_update/${lessor.slug}/`, payload)
            .then(response => {
                if(checkApiStatus(response)){
                    toggleModalFn();
                    getResponseBack();
                    enqueueSnackbar(response.data.message, { variant: 'success',anchorOrigin:{horizontal:'right', vertical:'top'}});
                }
                setLoading(false);
            })
        }else{
            setError(validationInputs)
        }
    }
    return(
        <Dialog
            open={editProfile.modal}
            onClose={toggleModalFn}
            className='console-management-modal'
            maxWidth="md"
        >
            <DialogTitle id="scroll-dialog-title">
                Edit {jetStreamInstance?"Lessor/Holdco":"Lessor"} Profile
            </DialogTitle>
            <DialogContent dividers={true}>
                <Grid container spacing={1}>
                    <Grid item md={6}>
                        <TextField 
                            disabled
                            required
                            id='name'
                            label='Name'
                            value={lessor?.name}
                            fullWidth
                            margin="normal"
                            error={error.name}
                            helperText={error?.name||''}
                            onChange={(e) => onFieldChange('name', e.target.value)}
                            onFocus={() => setError({...error,'name':''})}
                            InputLabelProps={{shrink: true}}
                            variant='outlined'
                        />
                    </Grid>
                    <Grid item md={6}>
                        <TextField 
                            id='contact_address'
                            label='Contact Address'
                            value={lessor?.contact_address}
                            fullWidth
                            margin="normal"
                            onChange={(e) => onFieldChange('contact_address', e.target.value)}
                            InputLabelProps={{shrink: true}}
                            variant='outlined'
                        />
                    </Grid>
                    <Grid item md={6}>
                        <TextField 
                            id='country'
                            label='Country'
                            value={lessor?.country}
                            fullWidth
                            margin="normal"
                            onChange={(e) => onFieldChange('country', e.target.value)}
                            InputLabelProps={{shrink: true}}
                            variant='outlined'
                        />
                    </Grid>
                 
                </Grid>
                <Grid item md={12}>
                        <TextField
                            id='email_signature'
                            label='Email Signature'
                            value={lessor?.email_signature}
                            fullWidth
                            margin="normal"
                            InputLabelProps={{ shrink: true }}
                            variant='outlined'
                            multiline
                            rows={3}
                            inputProps={{ maxLength: 255 }}
                            error={error.email_signature}
                            helperText={error?.email_signature||''}
                            onChange={(e) => onFieldChange('email_signature', e.target.value)}
                            onFocus={() => setError({...error,'email_signature':''})}
                        />
                    </Grid>
                    <span style={{ backgroundColor: "#fff1b6", fontSize: '11px' }} >Note: The signature added here will reflect on the email in which the invoices sent from SPARTA.</span>
            </DialogContent>
            <DialogActions>
                <Button disabled={isLoading} onClick={toggleModalFn} color='primary' size='small' variant='outlined'>Cancel</Button>
                <Button disabled={isLoading} onClick={onEditLessorProfile} color='primary' size='small' variant='contained'>
                    {isLoading ? <CircularProgress size={24} />:'Save'}
                </Button>
            </DialogActions>
        </Dialog>
    )
}
const LessorProfile = ({}) => {
    const classes = useStyles();
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [lessorInfo, setLessorInfo] = useState({})
    const [editProfile, setEditProfile] = useState({modal:false, data:null})
    const [ipList, setIpList] = useState([]);
    const [originalIpList, setOriginalIpList] = useState([]);
    const [ipErrors, setIpErrors] = useState({});
    const [confirmPopup, setConfirmPopup] = useState({modal:false, type:null, index:null});
    const isIpListDirty = JSON.stringify(ipList) !== JSON.stringify(originalIpList);
    useEffect(()=> {
        getLessorProfile()
        if(smbcInstance){
        getAllowedIPs()
        }
    },[]);

    const getAllowedIPs = () => {
        globalGetService(`console/allowedIPs`)
        .then(response => {
             if(checkApiStatus(response)){
                const data = response.data.data || [];
                const list = data.length ? data : [{ ip: '', label: '' }];
                setIpList(list);
                setOriginalIpList(list);
            }else{
                setIpList([{ ip: '', label: '' }]);
                setOriginalIpList([{ ip: '', label: '' }]);
            }
            setIpErrors({});
        })
    }
    const getLessorProfile = () => {
         setLoading(true)
        globalGetService(`console/lessor_tile_update/${getLocalStorageInfo().defaultLessor.slug}/`)
        .then(response => {
            if(checkApiStatus(response)){
                 setLoading(false)
                setLessorInfo(response.data.data)
            }else{
                setLoading(false) 
            }
        })
    }
    const onChangeAutoInvoice = (key, value) => {
        setLoading(true)
          const payload = { [key]: value };
        globalPutService(`console/auto-invoice-generate/`,payload)
        .then(response => {
            if(checkApiStatus(response)){
                enqueueSnackbar(response.data.message, { variant: 'success',anchorOrigin:{horizontal:'right', vertical:'top'}});
                getLessorProfile();
            }
            setLoading(false)
        })
    }
    const onChangeAssemblyInvoice = (value) => {
        setLoading(true)
        globalPostService(`console/lease-major-assembly-status-update/`,{lease_major_assembly_status:value})
        .then(response => {
            if(checkApiStatus(response)){
                enqueueSnackbar(response.data.message, { variant: 'success',anchorOrigin:{horizontal:'right', vertical:'top'}});
                getLessorProfile();
            }
            setLoading(false)
        })
    }
    const onUploadLessorProfile = (files) => {
        if(files.length){
            let formData = new FormData();
            formData.append('logo', files[0]);
            setLoading(true)
            globalPutService(`console/update-lessor/${getLocalStorageInfo().defaultLessor.slug}/`,formData)
            .then(response => {
                if(checkApiStatus(response)){
                    let userInfo = getLocalStorageInfo();
                    userInfo = {
                        ...userInfo,
                        defaultLessor: {
                            ...userInfo.defaultLessor,
                            logo:response.data.data.logo
                        }
                    }
                    localStorage.setItem('userInfo', JSON.stringify(userInfo));
                    enqueueSnackbar(response.data.message, { variant: 'success',anchorOrigin:{horizontal:'right', vertical:'top'}});
                    window.location.reload();
                }
                setLoading(false)
            })
        }
    }
    const utilizationApprovalFn = (flag) => {
        setLoading(true);
        globalPutService(`console/lessor_tile_update/${lessorInfo?.slug}/`, { ...lessorInfo, utilization_approval: flag })
            .then(response => {
                if (checkApiStatus(response)) {
                    getLessorProfile()
                    enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                }
                setLoading(false);
            })
    }
    const ipRestrictionToggleFn = (flag) => {
        setLoading(true);
        if (flag) {
            setLessorInfo({ ...lessorInfo, is_ip_validation_required: flag })
            setLoading(false);
        } else {
            globalPutService(`console/lessor_tile_update/${lessorInfo?.slug}/`, { ...lessorInfo, is_ip_validation_required: flag })
                .then(response => {
                    if (checkApiStatus(response)) {
                        getLessorProfile()
                        enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                    }
                    setLoading(false);
                })
        }
        if (!flag) {
            setIpList([{ ip: '', label: '' }]);
            setOriginalIpList([{ ip: '', label: '' }]);
        }
    }
    const onIpRestrictionToggle = (flag) => {
        if(!flag){
            setConfirmPopup({modal:true, type:'disableIpRestriction', index:null});
            return;
        }
        ipRestrictionToggleFn(flag);
    }
    const confirmDisableIpRestriction = () => {
        setConfirmPopup({modal:false, type:null, index:null});
        ipRestrictionToggleFn(false);
    }
    const saveIpList = (updatedList) => {
        setIpErrors({});
        setLoading(true);
        globalPostService(`console/allowedIPs`, { data: updatedList,is_enabled: true })
            .then(response => {
                if (checkApiStatus(response)) {
                    enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                    getAllowedIPs()
                }
                setLoading(false);
            })
    }
    const addIpRow = () => {
        setIpList([...ipList, { ip: '', label: '' }]);
    }
    const onIpFieldChange = (index, key, value) => {
        setIpList(ipList.map((row, i) => i === index ? { ...row, [key]: value } : row));
        if(ipErrors[index]){
            setIpErrors({ ...ipErrors, [index]: '' });
        }
    }
    const onSaveIpList = () => {
        const errors = {};
        const seenIps = {};
        ipList.forEach((row, index) => {
            const ip = row.ip?.trim();
            if(!ip || !regexConstants.ipAddress.test(ip)){
                errors[index] = 'Please add proper valid ip address';
            }else if(seenIps[ip] !== undefined){
                errors[index] = 'IP address already exist please add other ip';
                errors[seenIps[ip]] = 'IP address already exist please add other ip';
            }else{
                seenIps[ip] = index;
            }
        });
        if(Object.keys(errors).length){
            setIpErrors(errors);
            return;
        }
        saveIpList(ipList.map(row => ({ ...row, ip: row.ip.trim() })));
    }
    const onDeleteIpRow = (index) => {
        setConfirmPopup({modal:true, type:'deleteIp', index});
    }
    const confirmDeleteIpRow = () => {
        const index = confirmPopup.index;
        const row = ipList[index];
        const clearRowState = () => {
            const updatedErrors = { ...ipErrors };
            delete updatedErrors[index];
            setIpErrors(updatedErrors);
            setConfirmPopup({modal:false, type:null, index:null});
        }
        if(row?.id){
            setLoading(true);
            globalPostService(`console/allowedIPs`, {data:[{...row,is_deleted:true}]})
                .then(response => {
                    if(checkApiStatus(response)){
                        enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                        getAllowedIPs();
                    }
                     getAllowedIPs();
                    setLoading(false);
                    clearRowState();
                })
        }else{
            const updatedList = ipList.filter((_, i) => i !== index);
            setIpList(updatedList.length ? updatedList : [{ ip: '', label: '' }]);
            clearRowState();
        }
    }
    const onConfirmPopupAction = () => {
        if(confirmPopup.type === 'disableIpRestriction'){
            confirmDisableIpRestriction();
        }else if(confirmPopup.type === 'deleteIp'){
            confirmDeleteIpRow();
        }
    }
    return(
        <div className="console-forms-fields" style={{position:'relative'}}>
            {checkPermission('console', 'lessor_configuration','U') ?
                <span  style={{position:'absolute', top:'-3px', right:'0'}} onClick={() => setEditProfile({modal:true,data:lessorInfo})}><EditIcon style={{ cursor: 'pointer' }} color='primary' fontSize='small' /></span>:null
            }
            
            <Grid container spacing={1}>
                <Grid item md={2}>
                    <div style={{textAlign:'center'}}>
                        <span style={{position:'relative'}}>
                            <Avatar src={lessorInfo?.logo || null} alt={''} style={{width:'100px', height:'100px', margin:'0 auto'}} />
                            {checkPermission('console', 'lessor_configuration','U') ?
                                <span style={{position:'absolute', bottom:'0', textAlign:'center', cursor:'pointer'}}>
                                    <input onChange={(e) => onUploadLessorProfile(e.target.files)} accept="image/*" className={classes.input} id="icon-button-file" type="file" />
                                    <label htmlFor="icon-button-file">
                                        <IconButton color="primary" aria-label="upload picture" component="span">
                                            <PhotoCamera color='primary' fontSize="small" />
                                        </IconButton>
                                    </label>
                                </span>:null
                            }
                        </span>
                    </div>
                </Grid>
                <Grid item md={10}>
                    <Grid container spacing={1}>
                        <Grid item md={4}>
                            <TextField 
                                disabled
                                id='name'
                                label='Name'
                                value={lessorInfo?.name}
                                fullWidth
                                margin="normal"
                                InputLabelProps={{shrink: true}}
                                variant='outlined'
                            />
                        </Grid>
                        <Grid item md={4}>
                            <TextField 
                                disabled
                                id='contact_address'
                                label='Contact Address'
                                value={lessorInfo?.contact_address}
                                fullWidth
                                margin="normal"
                                InputLabelProps={{shrink: true}}
                                variant='outlined'
                            />
                        </Grid>
                        <Grid item md={4}>
                            <TextField 
                                disabled
                                id='country'
                                label='Country'
                                value={lessorInfo?.country}
                                fullWidth
                                margin="normal"
                                InputLabelProps={{shrink: true}}
                                variant='outlined'
                            />
                        </Grid>
                        
                            <Grid item md={12} style={{ background: '#f1f1f1', padding: '10px 15px', marginTop: '5px' }}>
                                {/* <div > */}
                                   {getLocalStorageInfo()?.user?.permission?.contracts ?
                                    <Grid container spacing={1}>
                                        <Grid item md={4}>
                                            <FormControl component="fieldset">
                                                <FormLabel component="legend" style={{display:'flex', alignItems:'center'}}>Auto-Invoice Generation <Tooltip title='Please note currently auto generation of invoice is only applicable on Rental invoices for assets with Fixed Monthly Lease Rental Rates and Lease Duration Type: Fixed Date' arrow><InfoIcon color='primary' fontSize='small' /></Tooltip></FormLabel>
                                                <FormControlLabel
                                                    control={<Switch color='primary' checked={lessorInfo?.auto_invoice_generate === 1 ? true : false} onChange={(e) => checkPermission('console', 'lessor_configuration', 'U') ? onChangeAutoInvoice('auto_invoice_generate', e.target.checked ? 1 : 0) : e.preventDefault()} name="gilad" />}
                                                    label={lessorInfo?.auto_invoice_generate === 1 ? 'Enabled' : 'Disabled'}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item md={4}>
                                            <FormControl  component="fieldset">
                                                <FormLabel style={{display:'flex', alignItems:'center'}} component="legend">
                                                    Invoice Approval Process
                                                    <Tooltip title='Enabling this will activate the approval mechanism for the invoices' arrow>
                                                        <InfoIcon color='primary' fontSize='small' />
                                                    </Tooltip>
                                                </FormLabel>
                                                <FormControlLabel
                                                    control={<Switch color="primary" checked={!!lessorInfo?.is_invoice_approval} onChange={(e) =>  onChangeAutoInvoice('is_invoice_approval', e.target.checked) } name="invoiceApproval" />}
                                                    label={!!lessorInfo?.is_invoice_approval ? 'Enabled' : 'Disabled'}
                                                />
                                            </FormControl>

                                        </Grid>
                                        <Grid item md={4}>
                                            <FormControl component={'fieldset'}>
                                                <FormLabel style={{display:'flex', alignItems:'center'}} component={'legend'}>
                                                    Invoice Validation Process
                                                    <Tooltip title=' By enabling this, the user will be shown a pop-up message when generating a new invoice if the previous invoice is either sent, paid in excess or partially paid.'>
                                                        <InfoIcon color='primary' fontSize='small'/>
                                                    </Tooltip>
                                                </FormLabel>
                                                <FormControlLabel
                                                control={<Switch color='primary' checked={lessorInfo.is_invoice_validation || false} onChange={(e)=>onChangeAutoInvoice('is_invoice_validation', e.target?.checked)} name='invoiceValidation'/>}
                                                label={lessorInfo?.is_invoice_validation ? 'Enabled' : 'Disabled'}
                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>: null}
                            <Grid container spacing={1}>
                                {(smbcInstance || testLessor) && getLocalStorageInfo()?.user?.group_profile_order?.id === 0 ?
                                    <Grid item md={6}>
                                        <FormControl component="fieldset">
                                            <FormLabel component="legend" style={{ display: 'flex', alignItems: 'center' }}>Utilization Approval flow <Tooltip title='Enabling this will activate the approval mechanism for the Utilization.' arrow><InfoIcon color='primary' fontSize='small' style={{ marginLeft: "5px" }} /></Tooltip></FormLabel>
                                            <FormControlLabel
                                                control={<Switch color='primary' checked={lessorInfo?.utilization_approval ? lessorInfo?.utilization_approval : false} onChange={(e) => utilizationApprovalFn(e.target.checked)} name="utilization_approval" />}
                                                label={lessorInfo?.utilization_approval ? 'Enabled' : 'Disabled'}
                                            />
                                        </FormControl>
                                    </Grid> : null}
                                {smbcInstance && getLocalStorageInfo()?.user?.group_profile_order?.id === 0 ?
                                    <Grid item md={6}>
                                        <FormControl component="fieldset">
                                            <FormLabel component="legend" style={{ display: 'flex', alignItems: 'center' }}>IP Restriction <Tooltip title='This is for SAEL users only.' arrow><InfoIcon color='primary' fontSize='small' style={{ marginLeft: "5px" }} /></Tooltip><span style={{ fontSize: '12px', fontStyle: 'italic', color: '#666' }}> This is for SAEL users only.</span></FormLabel>
                                            <FormControlLabel
                                                control={<Switch color='primary' checked={!!lessorInfo?.is_ip_validation_required} onChange={(e) => onIpRestrictionToggle(e.target.checked)} name="is_ip_validation_required" />}
                                                label={lessorInfo?.is_ip_validation_required ? 'Enabled' : 'Disabled'}
                                            />
                                        </FormControl>
                                    </Grid> : null}
                                {smbcInstance && getLocalStorageInfo()?.user?.group_profile_order?.id === 0 ?
                                    <Grid item md={12}>
                                        {lessorInfo?.is_ip_validation_required ?
                                            <>
                                                <div style={{ textAlign: 'right', marginBottom: '6px' }}>
                                                    <Button size='small' color='primary' variant='outlined' startIcon={<AddIcon fontSize='small' />} onClick={addIpRow}>Add Trusted IP</Button>
                                                </div>
                                                <TableContainer component={Paper} variant='outlined'>
                                                    <Table stickyHeader size='small' className='mui-table-format'>
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell style={{ width: '40%' }}>IP Address <span style={{color:'red'}}>*</span></TableCell>
                                                                <TableCell style={{ width: '40%' }}>Label (Optional)</TableCell>
                                                                <TableCell style={{ width: '20%' }} align='center'>Action</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody className='ip-address-restriction'>
                                                            {ipList?.map((row, index) => (
                                                                <TableRow key={index}>
                                                                    <TableCell style={{ verticalAlign: 'top' }}>
                                                                        <TextField
                                                                            fullWidth
                                                                            size='small'
                                                                            margin='dense'
                                                                            variant='outlined'
                                                                            placeholder='Enter IP Address'
                                                                            value={row?.ip}
                                                                            error={!!ipErrors[index]}
                                                                            helperText={ipErrors[index] || ''}
                                                                            inputProps={{ maxLength: 255 }}
                                                                            onChange={(e) => onIpFieldChange(index, 'ip', e.target.value)}
                                                                        />
                                                                    </TableCell>
                                                                    <TableCell style={{ verticalAlign: 'top' }}>
                                                                        <TextField
                                                                            fullWidth
                                                                            size='small'
                                                                            margin='dense'
                                                                            variant='outlined'
                                                                            value={row.label}
                                                                            inputProps={{ maxLength: 255 }}
                                                                            onChange={(e) => onIpFieldChange(index, 'label', e.target.value)}
                                                                        />
                                                                    </TableCell>
                                                                    <TableCell style={{ verticalAlign: 'top', paddingTop: '12px' }} align='center'>
                                                                        <Tooltip title='Delete'>
                                                                            <IconButton size='small' onClick={() => onDeleteIpRow(index)}><DeleteIcon fontSize='small' color='error' /></IconButton>
                                                                        </Tooltip>
                                                                    </TableCell>
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                                <div style={{ textAlign: 'right', marginTop: '10px' }}>
                                                    <Button size='small' color='primary' variant='contained' disabled={isLoading || !isIpListDirty} onClick={onSaveIpList}>Save</Button>
                                                </div>
                                            </> : null
                                        }
                                    </Grid> : null}
                            </Grid>
                            {/* </div> */}
                        </Grid>

                        <Grid item md={6}>
                            <TextField
                                disabled
                                id='email_signature'
                                label='Email Signature'
                                value={lessorInfo?.email_signature}
                                fullWidth
                                margin="normal"
                                InputLabelProps={{ shrink: true }}
                                variant='outlined'
                                multiline
                                rows={3}
                                inputProps={{ maxLength: 255 }}
                            />
                        </Grid>
                        <span style={{ backgroundColor: "#fff1b6", fontSize: '11px', marginLeft : "4px"}} >   Note: The signature added here will reflect on the email in which the invoices sent from SPARTA.</span>
                    </Grid>
                </Grid>
            </Grid>
            { editProfile.modal ?
                <EditLessorProfile
                    editProfile={editProfile}
                    toggleModalFn={() => setEditProfile({modal:false, data:null})}
                    getResponseBack={() => getLessorProfile()}
                />:null
            }
            <DeletePopUp
                modal={confirmPopup.modal}
                title={confirmPopup.type === 'disableIpRestriction' ? 'Disable IP Restriction' : 'Delete IP Address'}
                content={confirmPopup.type === 'disableIpRestriction' ? 'Are you sure you want to disable IP restriction? This will remove IP-based access control for this lessor.' : 'Deleting this IP address will also remove access for all users associated with it.'}
                toggleModalFn={() => setConfirmPopup({modal:false, type:null, index:null})}
                deleteRecordFn={onConfirmPopupAction}
                confirmText='Yes'
            />
            { isLoading ? <PageLoader />:null }
        </div>
    )
}
export default LessorProfile;